var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
var getAsyncLocalStorage = function() {
  if (isBrowser) {
    console.error("You should not get async storage in browser");
    return null;
  } else {
    try {
      var serverStorage = require("./async_storage.server");
      return serverStorage.getAsyncLocalStorage();
    } catch (err) {
      console.error("Failed to load server async storage", err);
      return null;
    }
  }
};
export {
  getAsyncLocalStorage
};
